import React, { useEffect, useState } from 'react';
import { Tr, Td, P } from './styles';
import { Row, Col } from 'reactstrap';
import ReactLoader from '../../../../../../components/Loader';
import { Table } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import DailyStockService from '../../../service/DailyStock';
import { toast } from 'react-toastify';
export const CheckProductAvailabilityModal = ({
  isModalOpenCheck,
  setIsModalOpenCheck,
  filial,
  data
}) => {
  const [totalProductsStock, setTotalProductsStock] = useState([]);
  const [dailyProductsStock, setDailyProductsStock] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const toggleModal = () => {
    setIsModalOpenCheck(!isModalOpenCheck);
  };

  const columns = [
    ' ',
    'P5',
    'P8',
    'P13',
    'P20',
    'P45',
    'GRANEL(Kg)',
    'P5 Total',
    'P8 Total',
    'P13 Total',
    'P20 Total',
    'P45 Total',
    'GRANEL Total(Kg)'
  ];

  const [lines, setLines] = useState([
    '06:00-07:00',
    '07:00-08:00',
    '08:00-09:00',
    '09:00-10:00',
    '10:00-11:00',
    '11:00-12:00',
    '12:00-13:00',
    '13:00-14:00',
    '14:00-15:00',
    '15:00-16:00',
    '16:00-17:00',
    '17:00-18:00',
    '18:00-19:00',
    '19:00-20:00',
    '20:00-21:00',
    '21:00-22:00',
    'Total',
    'CIF',
    'FOB',
    'Produção Extra',
    'Complemento de Programação',
    'Transferência'
  ]);

  useEffect(() => {
    getDailyStock(filial, data);
  }, []);

  const getDailyStock = (filialId, data) => {
    setIsloading(true);
    DailyStockService.getDailyStock(filialId, data)
      .then((response) => {
        let sortedTotalProductStock = response.data.data[0].map((produto) => {
          produto.estoquesPorHora = produto.estoquesPorHora.sort((a, b) => {
            return parseInt(a.horaInicial) - parseInt(b.horaInicial);
          });
          return produto;
        });
        let sortedDailyProductStock = response.data.data[1].map((produto) => {
          produto.estoquesPorHora = produto.estoquesPorHora.sort((a, b) => {
            return parseInt(a.horaInicial) - parseInt(b.horaInicial);
          });
          return produto;
        });
        setTotalProductsStock(sortedTotalProductStock);

        setLines([
          ...generateLines(sortedTotalProductStock[0].estoquesPorHora.length),
          'Total',
          'CIF',
          'FOB',
          'Produção Extra',
          'Complemento de Programação',
          'Transferência'
        ]);
        setDailyProductsStock(sortedDailyProductStock);
        setIsloading(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          error.response.data.message || 'Ocorreu um erro ao receber o estoque',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      });
  };

  const generateLines = (length) => {
    let newArr = [];
    for (let index = 6; index < length + 6; index++) {
      if (index === 9) {
        newArr.push(`0${index}:00-${index + 1}:00`);
      } else if (index < 10 && index !== 9) {
        newArr.push(`0${index}:00-0${index + 1}:00`);
      } else {
        newArr.push(`${index}:00-${index + 1}:00`);
      }
    }

    return newArr;
  };

  const handleDailyStock = (productName, index, stock) => {
    if (stock && stock.length > 0) {
      let filteredProduct = stock.filter((produto) => {
        return produto.produto === productName;
      });

      if (filteredProduct.length > 0) {
        return filteredProduct.map((produto, teste) => {
          if (produto.estoquesPorHora && produto.estoquesPorHora[index]) {
            return produto.estoquesPorHora[index].quantidade;
          } else if (index === produto.estoquesPorHora.length) {
            return produto.total;
          } else if (index === produto.estoquesPorHora.length + 1) {
            return produto.cif;
          } else if (index === produto.estoquesPorHora.length + 2) {
            return produto.fob;
          } else if (index === produto.estoquesPorHora.length + 3) {
            return produto.producaoExtra;
          } else if (index === produto.estoquesPorHora.length + 4) {
            return produto.complementoDeProgramacao;
          } else if (index === produto.estoquesPorHora.length + 5) {
            return produto.transferencia;
          } else {
            return 0;
          }
        });
      } else {
        return 0;
      }
    }
    return 0;
  };

  return (
    <>
      <Row className="mb-3" style={{ overflow: 'auto' }}>
        <Col
          style={{
            height: '31rem',
            width: '100%',
            display: 'flex'
          }}
        >
          {isLoading ? (
            <Row
              style={{
                display: `${isLoading ? 'flex' : 'none'}`,
                alignItems: 'center'
              }}
              className="justify-content-md-center"
            >
              <ReactLoader />
            </Row>
          ) : (
            <Table>
              <thead>
                <tr>
                  {columns.map((column, index) => (
                    <th
                      style={{
                        zIndex: '100',
                        whiteSpace: 'initial',
                        textAlign: 'center',
                        position: 'sticky',
                        top: '0',
                        fontWeight: 'bold',
                        // padding: '1rem',
                        backgroundColor: '#f6f9fc'
                      }}
                      key={index}
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {lines.map((linha, index) => {
                  return (
                    <Tr key={index}>
                      <td
                        style={{
                          padding: '0.1rem 0',
                          whiteSpace: 'initial',
                          position: 'sticky',
                          left: '0',
                          // fontSize: '0.7rem',
                          backgroundColor: 'white'
                        }}
                      >
                        {linha}
                      </td>

                      <Td style={{ padding: '0' }}>
                        <P>
                          {handleDailyStock('P5', index, dailyProductsStock)}
                        </P>
                      </Td>

                      <Td style={{ padding: '0' }}>
                        <P>
                          {handleDailyStock('P8', index, dailyProductsStock)}
                        </P>
                      </Td>

                      <Td style={{ padding: '0' }}>
                        <P>
                          {handleDailyStock('P13', index, dailyProductsStock)}
                        </P>
                      </Td>

                      <Td style={{ padding: '0' }}>
                        <P>
                          {handleDailyStock('P20', index, dailyProductsStock)}
                        </P>
                      </Td>

                      <Td style={{ padding: '0' }}>
                        <P>
                          {handleDailyStock('P45', index, dailyProductsStock)}
                        </P>
                      </Td>

                      <Td style={{ padding: '0' }}>
                        <P>
                          {handleDailyStock(
                            'GRANEL',
                            index,
                            dailyProductsStock
                          )}
                        </P>
                      </Td>

                      {index > 17 ? null : (
                        <>
                          <Td style={{ padding: '0' }}>
                            <P>
                              {handleDailyStock(
                                'P5',
                                index,
                                totalProductsStock
                              )}
                            </P>
                          </Td>

                          <Td style={{ padding: '0' }}>
                            <P>
                              {handleDailyStock(
                                'P8',
                                index,
                                totalProductsStock
                              )}
                            </P>
                          </Td>

                          <Td style={{ padding: '0' }}>
                            <P>
                              {handleDailyStock(
                                'P13',
                                index,
                                totalProductsStock
                              )}
                            </P>
                          </Td>
                          <Td style={{ padding: '0' }}>
                            <P>
                              {handleDailyStock(
                                'P20',
                                index,
                                totalProductsStock
                              )}
                            </P>
                          </Td>

                          <Td style={{ padding: '0' }}>
                            <P>
                              {handleDailyStock(
                                'P45',
                                index,
                                totalProductsStock
                              )}
                            </P>
                          </Td>

                          <Td style={{ padding: '0' }}>
                            <P>
                              {handleDailyStock(
                                'GRANEL',
                                index,
                                totalProductsStock
                              )}
                            </P>
                          </Td>
                        </>
                      )}
                    </Tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
      <Row className="md-3" style={{ marginLeft: '0.938rem' }}>
        <ReactButton
          btnColor="cancelation"
          onClick={() => {
            toggleModal();
          }}
        >
          Cancelar
        </ReactButton>
      </Row>
    </>
  );
};
